import { render, staticRenderFns } from "./login-card.vue?vue&type=template&id=d1077b38&scoped=true"
import script from "./login-card.vue?vue&type=script&lang=js"
export * from "./login-card.vue?vue&type=script&lang=js"
import style0 from "./login-card.vue?vue&type=style&index=0&id=d1077b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1077b38",
  null
  
)

export default component.exports